import { render, staticRenderFns } from "./ModalLuxRuleList.vue?vue&type=template&id=1a8c86d5&scoped=true"
import script from "./ModalLuxRuleList.vue?vue&type=script&lang=js"
export * from "./ModalLuxRuleList.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxRuleList.vue?vue&type=style&index=0&id=1a8c86d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c86d5",
  null
  
)

export default component.exports